/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import { Random } from "random-js";
import axios from '@/axios.js'
import con from "@/firebase/firebaseInit.ts";
import firebase from 'firebase';
import Handlebars from 'handlebars';
import ls from "@/common/localStorage"

var role = ls.getSessionValueByKey('Role')
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id')
const clientCollectionName = "OA_UAT";
const storageRef = con.storageRef
var clientRef = con.eventDB.collection(clientCollectionName).doc("ClientList").collection("Clients");
var SINGLEEMAILAPIURL = con.SINGLEEMAILAPIURL;
var EncryptedLoginURL = con.EncryptedLoginURL;
var CheckUserValidAPI = con.CheckUserValidAPI;
var ClientAddAPI = con.ClientAddAPI;
var ClientEditAPI = con.ClientEditAPI;
var getGoogleSheetRows = con.getGoogleSheetRows;
export default {
    fetchClients({ commit }) {
        return new Promise((resolve, reject) => {
            let markers = []
            if (role == 1) {
                clientRef.get().then(querySnapshot => {
                    querySnapshot.docs.forEach(doc => {
                        markers.push(doc.data())
                    })
                    commit('SET_CLIENTS', markers)
                    resolve(markers)
                }).catch(function (error) {
                    console.log('Error getting client:', error)
                    reject(error)
                })
            } else {
                clientRef.where("ClientId", "==", Session_Client_Id).get().then(querySnapshot => {
                    querySnapshot.docs.forEach(doc => {
                        markers.push(doc.data())
                    })
                    commit('SET_CLIENTS', markers)
                    resolve(markers)
                }).catch(function (error) {
                    console.log('Error getting client:', error)
                    reject(error)
                })
            }

        })
    },
    fetchClient(context, id) {
        //console.log('fetchClient:' + id)
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {
                        ClientName: '',
                        ClientEmail: '',
                        Password: null,
                        Company: '',
                        ClientId: '',
                        UserFirstName: '',
                        UserLastName: '',
                        EventCount: 1,
                        EventCountEditable: (role == 1 ? true : false),
                        Editable: true,
                        EmailEditable: true,
                        CustomDomain: '',
                        AllowRegister: false,
                        EnableEmailOnlyLogin: false,
                        CreatedTime: new Date(),
                        EventListAssets: {
                            banner1125x156: '',
                            banner1242x171: '',
                            banner1440x176: '',
                            banner2048x88: '',
                            banner640x88: '',
                            banner750x103: '',
                            banner2732x88: '',
                            bg2048x2732: '',
                            bg2732x2048: '',
                            bodyTextColor: '',
                            topBar: '',
                            fontBar: ''
                        },
                        Favicon: '',
                        LastModifiedTime: new Date(),
                        LoginAssets: {
                            bg2048x2732: '',
                            bg2732x2048: '',
                            bodyTextColor: '',
                            loginButtonFillColor: '',
                            loginButtonTextColor: '',
                            logo: ''
                        },
                        SSODomain: [],
                        SSOEnabled: false,
                        reCAPTCHA: false,
                        SocialAuths: [{
                            Google: false,
                            LinkedIn: false,
                            Microsoft: false
                        }],
                        CustomSMTP: false,
                        SENDGRIDBaseUrl: null,
                        SENDGRIDApiKey: null,
                        SMTPServerAddress: null,
                        SMTPUserName: null,
                        SMTPPassword: null,
                        SMTPEncryptionType: null,
                        SMTPPortNumber: null,
                        crm_integration: {
                            IsPublished: false,
                            source: null,
                            credentials: null
                        },
                        StreamingClient: 'Zoom',
                        //Profile: '',
                        //Settings: {
                        //    Facebook: '',
                        //    GooglePlus: '',
                        //    LinkedIn: '',
                        //    Twitter: '',
                        //    Website: ''
                        //}
                        Infotext: 'Best Experienced on Laptop or Desktop with Chrome browser',
                        TermsOfUseText: 'By signing in , I Agree to the Privacy Policy and Terms of Use'
                    }
                })
            } else {
                clientRef.doc(`${id}`).get().then(function (doc) {
                    let docObj = doc.data()
                    docObj.EnableEmailOnlyLogin = docObj.EnableEmailOnlyLogin == undefined ? false : docObj.EnableEmailOnlyLogin;
                    docObj.LoginAssets = docObj.LoginAssets === undefined ? {} : docObj.LoginAssets;
                    docObj.LoginAssets.bodyTextColor = docObj.LoginAssets.bodyTextColor === undefined ? '' : docObj.LoginAssets.bodyTextColor;
                    docObj.LoginAssets.loginButtonFillColor = docObj.LoginAssets.loginButtonFillColor === undefined ? '' : docObj.LoginAssets.loginButtonFillColor;
                    docObj.LoginAssets.loginButtonTextColor = docObj.LoginAssets.loginButtonTextColor === undefined ? '' : docObj.LoginAssets.loginButtonTextColor;
                    docObj.Infotext = docObj.Infotext === undefined ? 'Best Experienced on Laptop or Desktop with Chrome browser' : docObj.Infotext
                    docObj.TermsOfUseText = docObj.TermsOfUseText === undefined ? 'By signing in , I Agree to the Privacy Policy and Terms of Use' : docObj.TermsOfUseText
                    docObj.CustomSMTP = docObj.CustomSMTP ? docObj.CustomSMTP : false,
                        docObj.SENDGRIDBaseUrl = docObj.SENDGRIDBaseUrl ? docObj.SENDGRIDBaseUrl : null,
                        docObj.SENDGRIDApiKey = docObj.SENDGRIDApiKey ? docObj.SENDGRIDApiKey : null,
                        docObj.SMTPServerAddress = docObj.SMTPServerAddress ? docObj.SMTPServerAddress : null,
                        docObj.SMTPUserName = docObj.SMTPUserName ? docObj.SMTPUserName : null,
                        docObj.SMTPPassword = docObj.SMTPPassword ? docObj.SMTPPassword : null,
                        docObj.SMTPEncryptionType = docObj.SMTPEncryptionType ? docObj.SMTPEncryptionType : null,
                        docObj.SMTPPortNumber = docObj.SMTPPortNumber ? docObj.SMTPPortNumber : null,
                        docObj.EventListAssets.bodyTextColor = docObj['EventListAssets']['bodyTextColor'] ? docObj['EventListAssets']['bodyTextColor'] : ''
                    docObj.EventListAssets.topBar = docObj['EventListAssets']['topBar'] ? docObj['EventListAssets']['topBar'] : ''
                    docObj.EventListAssets.fontBar = docObj['EventListAssets']['fontBar'] ? docObj['EventListAssets']['fontBar'] : ''

                    if (docObj.crm_integration) {
                        docObj.crm_integration = docObj.crm_integration
                        docObj.crm_integration.credentialstring = docObj.crm_integration.credentials
                        docObj.crm_integration.credentials = {
                            env: "******",
                            password: "******",
                            sitename: "******",
                            username: "******",
                        }
                    }
                    else {
                        docObj.crm_integration = {
                            IsPublished: false,
                            source: null,
                            credentials: {
                                env: null,
                                password: null,
                                sitename: null,
                                username: null
                            }
                        }
                    }

                    if (docObj.CustomDomain.toLowerCase().indexOf("e2m.live") >= 0) {
                        let CustomDomainArr = (docObj.CustomDomain).split('.')
                        docObj.CustomDomain = CustomDomainArr[0]
                    }
                    docObj.EventCountEditable = (role == 1 ? true : false)
                    docObj.Editable = (role == 1 ? true : false)
                    docObj.EmailEditable = false;
                    //docObj.Password = "Unknown";
                    resolve({ status: 200, data: docObj })
                }).catch(function (error) {
                    //console.log('Error getting mapped client:', error)
                    reject(error)
                })
            }

        })
    },
    updateClientBK(context, field) {
        //console.log(atob(field.id));
        //console.log(field);
        return new Promise((resolve, reject) => {
            let docObj = {
                ClientName: field.data.ClientName,
                Company: field.data.Company,
                UserFirstName: field.data.UserFirstName,
                UserLastName: field.data.UserLastName,
                //EventCount: field.data.EventCount,
                //CustomDomain: field.data.CustomDomain,
                EnableEmailOnlyLogin: field.data.EnableEmailOnlyLogin,
                LastModifiedDate: new Date()
            }
            if (role == 1) {
                docObj.EventCount = field.data.EventCount
                let uerObj = {
                    Email: field.data.ClientEmail,
                    Password: field.data.Password
                }
            }
            clientRef.doc(`${field.id}`).update(docObj)
                .then(function (doc) {
                    resolve({ status: 200, message: 'Data Updated.' })
                    context.dispatch('updateCluentBrandingJSON', field.id).then(res => {
                        debugger;
                    });
                }).catch(function (error) {
                    //console.log('Error getting update client:', error)
                    reject(error)
                })
        })
    },
    updateClient(context, field) {
        return new Promise((resolve, reject) => {
            let docObj = {
                ClientName: field.data.ClientName.trim(),
                Company: field.data.Company.trim(),
                UserFirstName: field.data.UserFirstName.trim(),
                UserLastName: field.data.UserLastName.trim(),
                EnableEmailOnlyLogin: field.data.EnableEmailOnlyLogin,
                AllowRegister: field.data.AllowRegister,
                EnableSelfService: field.data.EnableSelfService,
                LastModifiedDate: new Date()
            }
            if (role == 1) {
                docObj.EventCount = field.data.EventCount
            }

            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`
            }
            let requestData = {
                "id": `${field.id}`,
                "data": docObj
            };
            axios.post(ClientEditAPI, requestData, { headers: headers }).then(function (res) {
                if (res.data.status == 200)
                    resolve({ status: 200, message: 'Data Updated.' })
                else
                    resolve({ status: 500, message: 'Data Not Updated.' })
            }).catch(function (error) {
                reject(error)
            })
        })
    },
    addClientBK(context, field) {
        return new Promise((resolve, reject) => {
            if (field.data.ClientEmail == '') {
                resolve({ status: 500, message: 'Enter proper email!.' })
            } else {
                let CustomDomain = field.data.CustomDomain.toLowerCase();
                if (field.data.CustomDomain.indexOf(".") == -1) {
                    CustomDomain = CustomDomain + '.e2m.live';
                }
                clientRef.where("ClientEmail", "==", field.data.ClientEmail).get().then(function (snapShot) {
                    let doc = snapShot.docs[0];
                    if (snapShot.empty) {
                        clientRef.where("CustomDomain", "==", CustomDomain).get().then(function (snap) {
                            if (snap.empty) {
                                let AutoID = "C" + new Date().getTime();

                                let docObj = {
                                    ClientName: field.data.ClientName,
                                    ClientEmail: field.data.ClientEmail,
                                    Company: field.data.Company,
                                    ClientId: AutoID,
                                    UserFirstName: field.data.UserFirstName,
                                    UserLastName: field.data.UserLastName,
                                    EventCount: field.data.EventCount,
                                    CustomDomain: CustomDomain,
                                    AllowRegister: false,
                                    EnableEmailOnlyLogin: field.data.EnableEmailOnlyLogin,
                                    CreatedTime: new Date(),
                                    EventListAssets: {
                                        banner1125x156: '',
                                        banner1242x171: '',
                                        banner1440x176: '',
                                        banner2048x88: '',
                                        banner640x88: '',
                                        banner750x103: '',
                                        banner2732x88: '',
                                        bg2048x2732: '',
                                        bg2732x2048: '',
                                        bodyTextColor: ''
                                    },
                                    Favicon: '',
                                    LastModifiedTime: new Date(),
                                    LoginAssets: {
                                        bg2048x2732: '',
                                        bg2732x2048: '',
                                        bodyTextColor: '',
                                        loginButtonFillColor: '',
                                        loginButtonTextColor: '',
                                        logo: ''
                                    },
                                    SSODomain: [],
                                    SSOEnabled: false,
                                    reCAPTCHA: false,
                                    SocialAuths: [{
                                        Google: false,
                                        LinkedIn: false,
                                        Microsoft: false
                                    }]
                                }
                                //console.log(docObj)
                                context.dispatch('addUser', docObj).then(userId => {
                                    clientRef.doc(AutoID).set(docObj).then(function (doc) {
                                        clientRef.doc(AutoID).collection('Features').doc('PlanDetails').set({
                                            MaxAttendeesPerClient: 10,
                                            EnhancedEventBranding: false,
                                            AllowSessionOnDemandVideo: false,
                                            AllowSessionLiveSimulated: false,
                                            AllowSessionRoundtable: false,
                                            ShowBrandingEventSetup: false,
                                            MaxEventDays: 2,
                                            EventAccessPostEvent: false,
                                            EnhancedRegistration: false,
                                            ContractStartDate: new Date(),
                                            ContractEndDate: new Date(),
                                            PricePerExtraAttendee: 100
                                        })
                                        resolve({ status: 200, message: 'Data Added.', Id: AutoID })
                                    }).catch(function (error) {
                                        //console.log('Error getting update client:', error)
                                        reject(error)
                                    })
                                    context.dispatch('updateCluentBrandingJSON', AutoID).then(res => {
                                        debugger;
                                    });
                                })
                            } else {
                                resolve({ status: 500, message: 'Domain Already Exist! Try Another.' })
                            }
                        })
                    } else {
                        resolve({ status: 500, message: 'Email Already Exist!.' })
                    }
                })
            }
        })
    },
    addClient(context, field) {
        return new Promise((resolve, reject) => {
            if (field.data.ClientEmail == '') {
                resolve({ status: 500, message: 'Enter proper email!.' })
            } else {
                let CustomDomain = field.data.CustomDomain.toLowerCase();
                if (field.data.CustomDomain.indexOf(".") == -1) {
                    CustomDomain = CustomDomain + '.e2m.live';
                }
                let AutoID = "C" + new Date().getTime();

                let docObj = {
                    ClientName: field.data.ClientName.trim(),
                    ClientEmail: field.data.ClientEmail.trim(),
                    Company: field.data.Company.trim(),
                    ClientId: AutoID,
                    UserFirstName: field.data.UserFirstName.trim(),
                    UserLastName: field.data.UserLastName.trim(),
                    EventCount: field.data.EventCount,
                    CustomDomain: CustomDomain,
                    AllowRegister: false,
                    EnableEmailOnlyLogin: field.data.EnableEmailOnlyLogin ? field.data.EnableEmailOnlyLogin : false,
                    EnableSelfService: field.data.EnableSelfService ? field.data.EnableSelfService : false,
                }

                let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                let headers = {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${accessToken}`
                }
                let requestData = {
                    "data": docObj
                };
                axios.post(ClientAddAPI, requestData, { headers: headers }).then(function (res) {
                    if (res.data.status == 200)
                        resolve({ status: 200, message: 'Data Added.', Id: AutoID })
                    else
                        resolve({ status: 500, message: res.data.message, Id: AutoID })
                }).catch(function (error) {
                    reject(error)
                })
            }
        })
    },
    uploadFile(context, field) {
        return new Promise((resolve, reject) => {
            if (field.file && field.path) {
                let path = field.path;
                let file = field.file
                let metadata = {
                    'contentType': file.type
                }
                storageRef.child(path + file.name).put(file, metadata).then(function (snapshot) {
                    snapshot.ref.getDownloadURL().then(function (url) {
                        resolve(url.toString())
                    }).catch(err => { console.log(err) })
                }).catch(err => { console.log(err) })
            } else {
                resolve('')
            }
        })
    },
    updateCluentBrandingJSON(context, id) {
        debugger
        return new Promise((resolve, reject) => {
            clientRef.doc(`${id}`).get().then(function (doc) {
                clientRef.doc(id).collection('Features').doc('PostLoginOptions').get().then(function (PLdoc) {
                    if (doc.exists) {
                        var data = doc.data();

                        debugger;
                        let path = 'OA_UAT' + '/Clients/Hosts/' + data.CustomDomain + '.json';

                        let jsonObj = {};

                        jsonObj.ClientId = data.ClientId;
                        jsonObj.ClientName = data.ClientName;
                        jsonObj.clientSettings = data.clientSettings;
                        jsonObj.DefaultLandingPage = data.DefaultLandingPage;
                        jsonObj.LoginAssets = data.LoginAssets == undefined ? {} : data.LoginAssets;
                        jsonObj.LastModifiedTime = data.LastModifiedTime;
                        jsonObj.EventListAssets = data.EventListAssets == undefined ? {} : data.EventListAssets;
                        jsonObj.defaultEvent = data.defaultEvent ? data.defaultEvent : null;
                        jsonObj.Favicon = data.Favicon;
                        jsonObj.AllowRegister = data.AllowRegister;
                        jsonObj.EnableEmailOnlyLogin = data.EnableEmailOnlyLogin;
                        jsonObj.EnableSelfService = data.EnableSelfService ? data.EnableSelfService : false;
                        jsonObj.Infotext = data.Infotext;
                        jsonObj.TermsOfUseText = data.TermsOfUseText;
                        jsonObj.SSOEnabled = data.SSOEnabled;
                        jsonObj.reCAPTCHA = data.reCAPTCHA;
                        jsonObj.SocialAuths = data.SocialAuths == undefined ? {} : data.SocialAuths;
                        jsonObj.CustomDomain = data.CustomDomain;
                        jsonObj.SSODomain = data.SSODomain;
                        jsonObj.Company = data.Company;
                        jsonObj.MetaTitle = data.MetaTitle || null;
                        jsonObj.MetaDescription = data.MetaDescription || null;
                        jsonObj.MetaKeywords = data.MetaKeywords || null;
                        jsonObj.MetaImage = data.MetaImage || null;

                        jsonObj.PostLoginOptions = PLdoc.exists ? PLdoc.data() : null;

                        if (jsonObj) {
                            let json = JSON.stringify(jsonObj, null, 2);
                            const blob = new Blob([json], { type: "application/json" });

                            storageRef.child(path).put(blob, { 'contentType': 'application/json' }).then(function (snapshot) {
                                resolve("JSON updated");
                            });
                        }
                    }
                })
            });
        })
    },
    updateSettings(context, field) {
        //console.log(field.data.SocialAuths)
        return new Promise((resolve, reject) => {

            let docObj = {
                SocialAuths: field.data.SocialAuths,
                SSOEnabled: field.data.SSOEnabled,
                reCAPTCHA: field.data.reCAPTCHA != undefined ? field.data.reCAPTCHA : false,
                CustomSMTP: field.data.CustomSMTP,
                SENDGRIDBaseUrl: field.data.SENDGRIDBaseUrl,
                SENDGRIDApiKey: field.data.SENDGRIDApiKey,
                SMTPServerAddress: field.data.SMTPServerAddress,
                SMTPUserName: field.data.SMTPUserName,
                SMTPPassword: field.data.SMTPPassword,
                SMTPEncryptionType: field.data.SMTPEncryptionType,
                SMTPPortNumber: parseInt(field.data.SMTPPortNumber),
                // PrivacyPolicyURL: field.data.PrivacyPolicyURL,
                //crm_integration: field.data.crm_integration,
                Infotext: field.data.Infotext !== '' ? field.data.Infotext : 'Best Experienced on Laptop or Desktop with Chrome browser',
                //TermofUseURL: field.data.TermofUseURL
                TermsOfUseText: field.data.TermsOfUseText !== '' ? field.data.TermsOfUseText : 'By signing in , I Agree to the Privacy Policy and Terms of Use',
                DefaultLandingPage: field.data.defaultLandingPageModel,
                defaultEvent: field.data.defaultEvent,
                EventListAssets: field.data.EventListAssets,
                MetaTitle: field.data.MetaTitle,
                MetaDescription: field.data.MetaDescription,
                MetaKeywords: field.data.MetaKeywords
            }


            docObj.crm_integration = {
                IsEncrypted: field.data.crm_integration.IsEncrypted ? true : false,
                IsPublished: field.data.crm_integration.IsPublished,
                source: field.data.crm_integration.source,
                credentials: field.data.crm_integration.credentialstring ? field.data.crm_integration.credentialstring : null
            }
            docObj.clientSettings = {
                ShowCreateEventButton: field.data.showCreateEventButton,
                AddToCalender: field.data.addToCalender,
                DisplayEventsPerSection: field.data.displayEventsPerSection,
                EnableEventFilter: field.data.enableEventFilter,
                ShowSignInPopup: field.data.showSignInPopup,
                approval_type: field.data.approval_type,
                StreamingClient: field.data.StreamingClient
            }


            context.dispatch('encryptCredential', field.data.crm_integration).then(credString => {
                if (credString) {
                    docObj.crm_integration.credentials = credString
                    docObj.crm_integration.IsEncrypted = true
                }
                //console.log(docObj.crm_integration)
                context.dispatch('uploadImage', { file: field.data.faviconFile, clientId: field.id }).then(faviconFileURL => {
                    context.dispatch('uploadImage', { file: field.data.metaimageFile, clientId: field.id }).then(metaimageURL => {
                        if (faviconFileURL) docObj.Favicon = faviconFileURL;
                        if (metaimageURL) docObj.MetaImage = metaimageURL;
                        clientRef.doc(`${field.id}`).update(docObj).then(function (doc) {
                            resolve({ status: 200, message: 'Data Updated.' })

                            context.dispatch('updateCluentBrandingJSON', field.id).then(res => {
                                debugger;
                            });
                        })
                    })
                })
            })
        })
    },
    encryptCredential(context, crmObj) {
        return new Promise((resolve, reject) => {
            let headers = {
                "content-type": "application/json"
            }
            if (crmObj.credentials.env && crmObj.credentials.env != "******" &&
                crmObj.credentials.password && crmObj.credentials.password != "******" &&
                crmObj.credentials.sitename && crmObj.credentials.sitename != "******" &&
                crmObj.credentials.username && crmObj.credentials.username != "******"
            ) {
                axios.post(EncryptedLoginURL, crmObj.credentials, { headers: headers }).then((res) => {
                    resolve(res.data.result)

                })
            }
            else {
                resolve(null)
            }
        })
    },
    async getAutoId(context) {
        //let AutoId = 0;
        let promise = new Promise((resolve, reject) => {
            con.instanceDB.doc("AutoID").get().then(function (doc) {
                if (!doc.exists) {
                    con.instanceDB.doc("AutoID").set({ UserId: 0 })
                    resolve(1)
                } else {
                    con.instanceDB.doc("AutoID").update({
                        UserId: firebase.firestore.FieldValue.increment(1)
                    }).then(function () {
                        con.instanceDB.doc("AutoID").get().then(function (doc) {
                            resolve(doc.data().UserId)
                        })
                    })
                }
            })
        })

        let AutoId = await promise;
        AutoId = AutoId * 1000;
        return await AutoId.toString();
    },
    generateNumber(context, numberLength) {
        const random = new Random(); // uses the nativeMath engine
        //const value = random.hex(numberLength);
        const value = random.integer(100000, 999999);
        return value.toString();
    },
    uploadImage(context, field) {
        return new Promise((resolve, reject) => {
            if (field.file && field.clientId) {
                let path = clientCollectionName + "/" + field.clientId + "/";
                let file = field.file
                let metadata = {
                    'contentType': file.type
                }
                storageRef.child(path + (new Date().getTime()) + "_" + file.name).put(file, metadata).then(function (snapshot) {
                    snapshot.ref.getDownloadURL().then(function (url) {
                        resolve(url.toString())
                    })
                })
            } else {
                resolve('')
            }
        })
    },
    fetchBrandingJson(context, field) {
        let path = clientCollectionName + "/Clients/" + field.clientId + "/Branding.json";
        return new Promise((resolve, reject) => {
            storageRef.child(path).getDownloadURL().then(function (url) {
                // Found it. Do whatever

                axios.get(url.toString()).then(result => {
                    //console.log(typeof result.data)   
                    let jsonObj = null
                    if (typeof result.data == 'string')
                        jsonObj = eval('(' + result.data + ')');
                    else if (typeof result.data == 'object')
                        jsonObj = result.data
                    else
                        jsonObj = null
                    //let jsonObj = JSON.stringify(result.data)
                    //console.log(jsonObj)
                    resolve(jsonObj)
                }).catch((err) => {
                    //console.log(err) 
                    //resolve(null)
                })

            })
                .catch((err) => {
                    // Didn't exist... or some other error
                    //console.log(err)
                    resolve(null)
                })

        })
    },
    deleteBrandingJsonClient(context, field) {
        return new Promise((resolve, reject) => {
            clientRef.doc(`${field.clientId}`).get().then(function (doc) {
                let docObj = doc.data()
                docObj[field.updateField][field.filename] = ''
                clientRef.doc(`${field.clientId}`).update(docObj).then(function () {
                    context.dispatch('updateCluentBrandingJSON', field.clientId)
                    resolve({ status: 200, message: 'Data Updated.' })
                })
            })


        })
    },
    uploadBrandingJsonClientColor(context, field) {
        return new Promise((resolve, reject) => {
            if (field.data) {

                clientRef.doc(`${field.clientId}`).get().then(function (doc) {
                    let docObj = doc.data()
                    docObj['EventListAssets']['bodyTextColor'] = field.data['EventListAssets']['bodyTextColor']
                    docObj['EventListAssets']['topBar'] = field.data['EventListAssets']['topBar'] ? field.data['EventListAssets']['topBar'] : ''
                    docObj['EventListAssets']['fontBar'] = field.data['EventListAssets']['fontBar'] ? field.data['EventListAssets']['fontBar'] : ''
                    docObj['LoginAssets']['bodyTextColor'] = field.data['LoginAssets']['bodyTextColor']
                    docObj['LoginAssets']['loginButtonFillColor'] = field.data['LoginAssets']['loginButtonFillColor']
                    docObj['LoginAssets']['loginButtonTextColor'] = field.data['LoginAssets']['loginButtonTextColor']
                    clientRef.doc(`${field.clientId}`).update(docObj).then(function () {
                        resolve({ status: 200, message: 'Data Updated.' })

                        context.dispatch('updateCluentBrandingJSON', field.clientId).then(res => {
                            debugger;
                        });
                    })
                })

            } else {
                resolve('')
            }
        })
    },
    uploadBrandingJsonClient(context, field) {
        return new Promise((resolve, reject) => {
            if (field.file && field.updateField) {
                let updateField = field.updateField
                let updateFieldName = field.filename
                let path = clientCollectionName + "/Clients/" + field.clientId + "/";
                let file = field.file

                let extension = (file.name).split('.')
                let filename = field.filename + "_" + new Date().getTime() + "." + extension[1]
                let metadata = {
                    'contentType': file.type
                }


                storageRef.child(path + filename).put(file, metadata).then(function (snapshot) {
                    snapshot.ref.getDownloadURL().then(function (url) {
                        clientRef.doc(`${field.clientId}`).get().then(function (doc) {
                            let docObj = doc.data()
                            docObj[updateField][updateFieldName] = url.toString()
                            clientRef.doc(`${field.clientId}`).update(docObj).then(function () {
                                context.dispatch('updateCluentBrandingJSON', field.clientId)
                                resolve({ status: 200, message: 'Data Updated.' })
                            })
                        })

                    })
                }).catch((err) => { console.log(err) })

            } else {
                resolve('')
            }
        })
    },
    fetchClientFeatures(context, id) {
        return new Promise((resolve, reject) => {
            if (id) {
                let resultFeatures = []
                con.instanceDB.doc("Features").get().then(function (allFeatures) {
                    let availableFeatures = (allFeatures.exists ? allFeatures.data().Features : [])
                    clientRef.doc(id).collection('Features').doc('ClientFeatures').get().then(function (clientFeature) {
                        debugger;
                        let selectedFeatures = (clientFeature.exists ? clientFeature.data().Features : [])
                        if (selectedFeatures.length == 0) {
                            availableFeatures.forEach(feature => {
                                feature.selected = (feature.IsDefault ? true : false);
                                resultFeatures.push(feature);
                            });
                        } else {
                            availableFeatures.forEach(feature => {
                                let found = selectedFeatures.some(el => el.ID === feature.ID);
                                feature.selected = (found ? true : false);
                                resultFeatures.push(feature);
                            });
                        }
                        resultFeatures.sort(function (a, b) {
                            return (
                                a.selected > b.selected ? -1 : a.selected < b.selected ? 1 : 0
                            );
                        });
                        resolve({ status: 200, AllFeatures: resultFeatures });
                    })
                })

            }
        })
    },
    updateClientFeatures(context, field) {
        return new Promise((resolve, reject) => {
            let Features = []
            field.SelectedFeatures.forEach(feature => {
                if (feature.selected)
                    Features.push({ ID: feature.ID, Name: feature.Name, IsDefault: feature.IsDefault })
            })
            clientRef.doc(field.id).collection('Features').doc('ClientFeatures').get().then(function (doc) {
                if (doc.exists) {
                    clientRef.doc(field.id).collection('Features').doc('ClientFeatures').update({
                        Features: Features
                    }).then(function () {
                        resolve({ status: 200, message: "Features Updated" })
                    })
                } else {
                    clientRef.doc(field.id).collection('Features').doc('ClientFeatures').set({
                        Features: Features,
                        CreatedTime: new Date(),
                        LastModifiedTime: new Date()
                    }).then(function () {
                        resolve({ status: 200, message: "Features Created" })
                    })
                }
            })


        })
    },
    fetchClientPlanDetails(context, id) {
        return new Promise((resolve, reject) => {
            if (id) {
                clientRef.doc(id).collection('Features').doc('PlanDetails').get().then(function (doc) {
                    if (doc.exists)
                        resolve({ status: 200, PlanDetails: doc.data() })
                    else
                        resolve({ status: 200, PlanDetails: null })
                })

            }
        })

    },
    updateClientPlanDetails(context, field) {
        return new Promise((resolve, reject) => {
            if (field.id) {
                clientRef.doc(field.id).collection('Features').doc('PlanDetails').get().then(function (doc) {
                    if (doc.exists) {
                        clientRef.doc(field.id).collection('Features').doc('PlanDetails').update(field.PlanDetails).then(function () {
                            resolve({ status: 200, message: "Plan Details Updated" })
                        })
                    } else {
                        clientRef.doc(field.id).collection('Features').doc('PlanDetails').set(field.PlanDetails).then(function () {
                            resolve({ status: 200, message: "Plan Details Created" })
                        })
                    }
                })

            }
        })

    },
    fetchPostLoginOptions(context, id) {
        return new Promise((resolve, reject) => {
            if (id) {
                clientRef.doc(id).collection('Features').doc('PostLoginOptions').get().then(function (doc) {
                    if (doc.exists)
                        resolve({ status: 200, PostLoginOptions: doc.data() })
                    else
                        resolve({ status: 200, PostLoginOptions: null })
                })
            }
        })

    },
    fetchAllMenu(context, id) {
        return new Promise((resolve, reject) => {
            context.dispatch('fetchClientFeatures', id).then(res => {
                con.instanceDB.doc("Menu").get().then(function (doc) {
                    if (doc.exists && res.AllFeatures.length) {
                        let AllFeatureId = res.AllFeatures.map(feature => {
                            return feature.ID
                        })
                        let AllMenu = [];
                        doc.data().AllMenu.some(menu => {
                            let found = AllFeatureId.includes(menu.FeatureID) && menu.IsPublished && (menu.PositionInPage == 1 || menu.PositionInPage == 4)
                            if (found)
                                AllMenu.push(menu)
                        })
                        resolve(AllMenu)
                    }
                    else
                        resolve([])
                })
            })
        })
    },
    updateMenuIcon(context, field) {
        return new Promise((resolve, reject) => {
            let file = field.file
            let metadata = {
                'contentType': file.type
            }
            let path = clientCollectionName + "/" + field.clientId + "/";
            storageRef.child(path + '/MenuIcons/' + (new Date().getTime()) + "_" + file.name).put(file, metadata).then(function (snapshot) {
                snapshot.ref.getDownloadURL().then(function (url) {
                    resolve(url.toString())
                })
            })
        }).catch((err) => { reject(err) })
    },
    updateClientPostLoginOption(context, field) {
        return new Promise((resolve, reject) => {
            clientRef.doc(field.id).collection('Features').doc('PostLoginOptions').set(field.PostLoginOptions).then(function () {
                context.dispatch('updateCluentBrandingJSON', field.id)
                resolve({ status: 200, message: 'Data Updated' })
            }).catch(err => { reject(err) })
        })
    },
    sendForgetPassMail(context, field) {
        let promise = new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": "",
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                "data": {
                    "Email": field.Email.toLowerCase()
                }
            }
            con.instanceDB.doc("mailtpl").collection("forgotPass").doc("forgotPass").get().then(function (mailtpl) {
                let source = mailtpl.data().html;
                let template = Handlebars.compile(source);
                axios.post(CheckUserValidAPI, requestData, { headers: headers }).then(snapShot => {
                    if (!snapShot.data.userStatus) {
                        resolve({ status: 500, message: "Email does not exist!" })
                    } else {
                        let doc = snapShot.data.result;
                        let formatedText = {
                            //CustomDomain: clientDetail.data().CustomDomain,
                            //EventName: eventDetail.data().EventFullName,
                            CMSDomain: window.location.hostname,
                            Email: doc.Email,
                            Password: doc.Password,
                            FirstName: doc.FirstName,
                            //EventBanner: eventDetail.data().EventBanner,
                            //ClientEmail: clientDetail.data().ClientEmail
                        };
                        let html = template(formatedText);
                        let subject = mailtpl.data().subject
                        var requestData = {
                            "from": {
                                "email": mailtpl.data().from,
                                "name": "E2M Group"
                            },
                            "to": {
                                "name": doc.Name,
                                "email": doc.Email.toLowerCase()
                            },
                            "subject": subject,
                            "html": html
                        };
                        const headers = {
                            "Content-Type": "application/json"
                            //'MIME-Version': '1.0\r\n'
                        }
                        axios.post(SINGLEEMAILAPIURL, requestData, { headers: headers })
                            .then((response) => {
                                if (response.status == 200) {
                                    resolve({ status: 200, message: "Mail sent, please check Email." })
                                }

                            })
                            .catch((error) => { console.log(error) })
                    }

                }) // end of where in firebase

            })
        }) // end of promise

        return promise;

    },
    fetchBoothTemplates({commit}){
        return new Promise((resolve, reject) => {
            let templateData = [];
            con.instanceDB
              .doc("BoothDesigns")
              .collection("Templates")
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  if(doc.data().ImagePath && doc.data().PSDPath){
                    templateData.push({...doc.data(), id:doc.id});
                  }
                });
                resolve(templateData);
              });
          });
    },
    updateDefaultOptions(context, field) {
        return new Promise(async(resolve, reject) => {
            let tasks = [];
            let allTmps = await context.dispatch('fetchBoothTemplates');
            for(let tmplate of allTmps){
                let ClientsDefault = [];
                if(tmplate.ClientsDefault){
                    ClientsDefault = tmplate.ClientsDefault;
                }
                if (field.DefaultBoothTemplateId != tmplate.id && ClientsDefault.includes(field.clientId)) {                    
                    let index = ClientsDefault.indexOf(field.clientId);
                    if (index !== -1) {
                      ClientsDefault.splice(index, 1);
                    }
                }
                if (field.DefaultBoothTemplateId == tmplate.id && !ClientsDefault.includes(field.clientId)) {                    
                    ClientsDefault.push(field.clientId);                                       
                }
                tasks.push(con.instanceDB.doc("BoothDesigns").collection("Templates").doc(tmplate.id).update({ClientsDefault: ClientsDefault})); 
            }
            
            await Promise.allSettled(tasks);
            resolve({ status: 200, message: "Default Template Added." })
        })
    },
    fetchClientsEventList({ commit }, clientId){
        return new Promise(async(resolve, reject) => {
            let events = [];
            let snap = await clientRef.doc(clientId).collection('Events').get();         
            for(let doc of snap.docs){
                events.push({
                    EventFullName: doc.data().EventFullName,
                    EventId: doc.data().EventId,
                    Description: doc.data().Description ? doc.data().Description : null,
                    EventBannerShare: doc.data().EventBannerShare ? doc.data().EventBannerShare : null,
                    EventCollectionName: doc.data().EventCollectionName,
                    EventEndDate: doc.data().EventEndDate,
                    EventStartDate: doc.data().EventStartDate
                });
            }
            resolve(events);   
        })
    },
    removeRecord({ commit }, clientId) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/client-management/client/${clientId}`)
                .then((response) => {
                    commit('REMOVE_RECORD', clientId)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    getGoogleSheetRows(context, clientId) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'clientId': clientId,
                'instanceId': 'OA_UAT'
            }
            
            axios.get(getGoogleSheetRows, { headers: headers }).then(function (res) {
                if (res.status == 200)
                    resolve({primaryData:res.data.primaryData, metaData: res.data.metaData})
                else
                    resolve({primaryData:[], metaData: []})
            }).catch(function (error) {
                reject(error)
            })
        })
    },
}